import styled from "styled-components";
import { theme } from "@themes";

export const FormCard = styled.div`
  width: 450px;
  font-size: 14px;
  border: 1px solid ${({ theme }) => theme.primaryLight};
  border-radius: 5px;
  padding: 5px;
  position: absolute;
  background: ${({ theme }) => theme.neutral.white};
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: grid;
  grid-template-columns: 1fr;
  grid-auto-rows: minmax(5em, auto);
  box-shadow: 0px 4px 20px 0px ${({ theme }) => theme.primaryLight};
  input[type="date"] {
    font-size: 12px;
  }

  input[type="time"] {
    font-size: 12px;
  }

  .utc-label {
    padding: 5px;
  }

  Hr {
    border-top: 1px solid !important;
    width: 100%;
  }
  .m-top-5 {
    margin-top: 5px;
  }
  .m-top-10 {
    margin-top: 10px;
  }
  .m-top-33 {
    margin-top: 33px;
    @media only screen and (min-width: 250px) and (max-width: 512px) {
      margin-top: 0px;
    }
  }
  .m-top-25 {
    margin-top: 25px;
  }
  .form-check-input:checked {
    background-color: ${({ theme }) => theme.button.primary} !important;
    border-color: ${({ theme }) => theme.button.primary} !important;
  }

  .form-check-input:checked + label {
    font-weight: bold;
  }

  .close-recurring {
    position: relative !important;
    left: 30px !important;
  }
  .configuration-popup {
    @media only screen and (min-width: 250px) and (max-width: 512px) {
      width: 100%;
    }
  }
  .configuration-header {
    @media only screen and (min-width: 250px) and (max-width: 512px) {
      display: grid;
      grid-template-columns: 1fr 2fr;
    }
  }
`;

export const ButtonCreateGroup = styled.button`
  background: ${({ theme }) => theme.button.primary};
  color: ${({ theme }) => theme.neutral.white};
  font-size: 14px;
  font-weight: 500;
  border: none;
  box-shadow: 0px 4px 18px ${({ theme }) => theme.shadows.medium};
  border-radius: 5px;
  width: 100%;
  height: 43.21px;
  margin: 0px auto;
  font-family: ${({ theme }) => theme.secondaryFontFamilyFour};
  &:hover {
    box-shadow: 0px 4px 20px 0px ${({ theme }) => theme.shadows.strong};
    transform: translateY(-1px);
    cursor: pointer;
  }
`;
export const ButtonCancel = styled.a`
  color: ${({ theme }) => theme.primary.purple};
  width: 100%;
  height: 43.21px;
  margin: 0px auto;
  font-size: 14px;
  display: flex;
  font-weight: 500;
  justify-content: end;
  align-items: center;
  font-family: ${({ theme }) => theme.secondaryFontFamilyFour};
`;

export const ContainFormCheck = styled.div`
  margin: 4px;
  background-color: ${({ theme }) => theme.neutral.gray[400]};
  border-radius: 99px;
  float: left;
  width: 3em;
  height: 3em;
  &:hover {
    background: ${({ theme }) => theme.button.primary};
    cursor: pointer;
    color: ${({ theme }) => theme.neutral.white};
  }
`;

export const FormForCheck = styled.input`
  display: none;
  &:checked + span {
    background-color: ${({ theme }) => theme.button.primary};
    border-radius: 99px;
    color: ${({ theme }) => theme.neutral.white};
    height: 3em;
  }
`;

export const FormLabelCheck = styled.label`
  float: left;
  width: 3em;
  cursor: pointer;
  span {
    text-align: center;
    padding: 11px 0px;
    display: block;
  }
`;

export const SelectModalStyles = {
  control: (styles, { isFocused }) => ({
    ...styles,
    boxShadow: isFocused ? theme.text.disabled : theme.neutral.gray[700],
    borderColor: isFocused ? theme.text.disabled : theme.neutral.gray[700],
    ":hover": {
      ...styles[":hover"],
      borderColor: theme.text.disabled,
    },
  }),
  option: (styles, { data, isFocused }) => {
    return {
      ...styles,
      color: data.color,
      backgroundColor: isFocused ? theme.text.disabled : data.color,
      ":hover": {
        ...styles[":hover"],
        backgroundColor: theme.text.disabled,
      },
    };
  },
};
